import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { FlowRunStatuses } from '@ply-io/runner';

import TileProgressBarMenu from './TileProgressBarMenu.vue';
import { FlowRunAssetsKey } from './types';
import IconWarning from '@/components/FlowTreeBlock/assets/icon-exclamation-unknown.svg';
import { useInject } from '@/components/SideBar/composables';
import SuccessViSVG from '@/components/common/WorkflowStatus/assets/SuccessViSVG.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TileActions',
  props: {
    loading: { type: Boolean },
    isExpanded: { type: Boolean },
    allowExpand: { type: Boolean }
  },
  emits: ['update:isExpanded'],
  setup(__props: any, { emit }) {

const STATUS_TO_ICON: Partial<Record<FlowRunStatuses, unknown>> = {
	[FlowRunStatuses.Done]: SuccessViSVG,
	[FlowRunStatuses.Failed]: IconWarning,
};
const iconComponent = computed(() => (Object.keys(STATUS_TO_ICON).includes(status.value) ? STATUS_TO_ICON[status.value] : null));

const { status } = useInject(FlowRunAssetsKey);


return { __sfc: true,STATUS_TO_ICON, iconComponent, status, emit, TileProgressBarMenu }
}

})